exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box{-webkit-transition:all 1.5s cubic-bezier(.39,.575,.565,1);transition:all 1.5s cubic-bezier(.39,.575,.565,1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1269a866","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Orders_v2/Aggregates/Tables.vue
// module id = ZAUp
// module chunks = 0